module.exports = __webpack_public_path__ + "static/media/POSTRAK.5f69d473.pdf";